module.exports = __webpack_public_path__ + "img/antes_despues_204.4a42a92e.png";